import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { useSiteMeta } from "@/hooks/useSiteMeta";

export default function SiteShell({ children }) {
  const { pathname } = useLocation();
  useSiteMeta();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-iyaf-paper">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
